export const consts = {
  brand: "NKR",
  contactDetails: {
    phone: "0526053869",
    email: "naveishelly@gmail.com",
    whatsapp: "+972526053869",
    bookingUrl: "https://calendly.com/naveishelly/30min",
    whatsappPrefill: "Hi NKR! I'd like to chat about a project.",
  },

  nav: [
    { label: "Services", anchor: "services" },
    { label: "Industries", anchor: "industries" },
    { label: "Work", anchor: "work" },
    { label: "Pricing", anchor: "pricing" },
    { label: "FAQ", anchor: "faq" },
    { label: "Contact", anchor: "contact" },
  ],

  scarcity: {
    slotsLabel: "slots left this month",
    replyTime: "Reply within 4h · Mon–Thu",
    monthlySlots: 3,
  },

  hero: {
    badge: "Now booking — limited slots open",
    titleLine1: "Software",
    titleAccent: "that ships.",
    lede:
      "Landing pages, full-stack apps, automations, CRMs, Telegram & WhatsApp bots — designed to convert and built to last.",
    primaryCta: "Start a project",
    secondaryCta: "See what we build",
    marquee: [
      "Landing Pages",
      "Full-Stack Apps",
      "Automations",
      "CRMs",
      "Telegram Bots",
      "WhatsApp Bots",
      "AI Integrations",
    ],
    trustStrip: {
      label: "Built with",
      tools: ["React", "Node.js", "Java", "Stripe", "OpenAI", "Twilio", "MongoDB", "AWS"],
    },
    codePreview: {
      title: "deploy.sh",
      lines: [
        { type: "comment", text: "// NKR — ship in weeks, not months" },
        { type: "code", text: "$ npm run build" },
        { type: "muted", text: "✓ compiled successfully" },
        { type: "code", text: "$ git push origin main" },
        { type: "muted", text: "✓ deployed to production" },
        { type: "code", text: "$ curl /api/health" },
        { type: "success", text: '{"status": "shipped"}' },
      ],
    },
  },

  stats: {
    items: [
      { value: "50+", label: "Projects shipped" },
      { value: "10K+", label: "Hours saved by automations" },
      { value: "24h", label: "Average reply time" },
      { value: "100%", label: "Code you actually own" },
    ],
  },

  services: {
    eyebrow: "What we build",
    title: "Everything your business needs online.",
    lede:
      "Websites, booking systems, automations and bots — built end-to-end for small businesses that want to stop wasting time.",
    items: [
      {
        key: "landing",
        title: "Landing Pages",
        desc:
          "Conversion-tuned pages that turn cold traffic into paying customers. Lightning-fast, SEO-ready, A/B testable.",
        bullets: ["Built to convert", "Loads instantly", "Live in 3–7 days"],
      },
      {
        key: "fullstack",
        title: "Web Apps & Internal Tools",
        desc:
          "Online apps with logins, payments, and dashboards. Built so your team can use it on day one.",
        bullets: ["Looks great on phone & desktop", "Online payments built in", "Always online"],
      },
      {
        key: "automation",
        title: "Custom Automations",
        desc:
          "Connect the tools you already use and save hours every week. Workflows shaped around how you actually work.",
        bullets: ["Connects to your tools", "Slack & email alerts", "Whatever fits your business"],
      },
      {
        key: "crm",
        title: "Client Systems & CRMs",
        desc:
          "A client system your team will actually open every morning. Built around your real flow — not the tool's.",
        bullets: ["Track every client & deal", "Different access per person", "Reports + Excel export"],
      },
      {
        key: "telegram",
        title: "Telegram Bots",
        desc:
          "Bots for support, sales, alerts, and communities — running 24/7 with rock-solid uptime.",
        bullets: ["Smart commands", "Admin dashboard", "Payments built in"],
      },
      {
        key: "whatsapp",
        title: "WhatsApp Bots",
        desc:
          "Automation on the channel your customers actually open. Capture leads, answer support, send updates.",
        bullets: ["WhatsApp Business ready", "Smart auto-replies", "Saves to your client list"],
      },
    ],
  },

  industries: {
    eyebrow: "By industry",
    title: "Who we work with.",
    lede:
      "Real systems built for businesses like yours. We've shipped these before — and we know what works.",
    cta: "See how it works",
    items: [
      {
        slug: "whatsapp-bots-for-real-estate",
        key: "real-estate",
        name: "Real estate",
        tagline: "WhatsApp lead bots for agencies",
        outcome: "3× more booked viewings, no more missed leads",
        icon: "🏡",
      },
      {
        slug: "ecommerce-automation",
        key: "ecommerce",
        name: "Ecommerce",
        tagline: "Order, support & marketing automation",
        outcome: "Save 25+ hours/week of manual ops",
        icon: "🛒",
      },
      {
        slug: "booking-system-for-clinics-and-salons",
        key: "local-services",
        name: "Clinics, gyms & barber shops",
        tagline: "Online booking + WhatsApp reminders",
        outcome: "End no-shows. Save 10+ hours every week.",
        icon: "📅",
      },
    ],
  },

  niches: {
    "whatsapp-bots-for-real-estate": {
      hero: {
        eyebrow: "For real-estate agencies",
        title: "WhatsApp lead bots that book 3× more viewings.",
        lede:
          "Stop losing leads in DMs. We build a smart WhatsApp bot that captures, qualifies and routes every inquiry — 24/7 — straight into your agents' hands.",
        primaryCta: "Get my lead bot",
        secondaryCta: "See a demo",
        bullets: [
          "Captures every inbound lead, day or night",
          "Auto-qualifies by budget, area, timeline",
          "Routes to the right agent in real time",
          "Built on official WhatsApp Cloud API",
        ],
      },
      problems: {
        title: "Why agencies lose leads",
        items: [
          "Inquiries come in across 5 different phones — half get missed.",
          "Agents reply hours later. By then, the buyer messaged 3 competitors.",
          "No follow-up system, so warm leads go cold without a push.",
        ],
      },
      solution: {
        title: "What we ship",
        items: [
          {
            t: "Smart intake",
            d: "Bot greets, captures name + budget + area, sends instant confirmation.",
          },
          {
            t: "Auto-routing",
            d: "Lead routed to the right agent based on area / language / shift.",
          },
          {
            t: "Follow-ups",
            d: "Auto re-engagement at 24h and 72h if the lead goes quiet.",
          },
          {
            t: "CRM sync",
            d: "Every lead lands in your CRM (or one we build) with full chat history.",
          },
        ],
      },
      proof: {
        title: "Real result",
        quote:
          "We were losing one in three leads to missed messages. Two months in we book 3× more viewings, and our agents stopped being on-call all night.",
        name: "Daniel R.",
        role: "Founder, IL real-estate agency",
      },
      pricing: {
        title: "Investment",
        priceFrom: "From $1,250",
        timeline: "1–2 weeks to live",
        includes: [
          "Bot setup on official WhatsApp Cloud API",
          "Custom intake & routing flow",
          "Admin dashboard",
          "CRM integration",
          "30 days of post-launch support",
        ],
      },
      faq: [
        {
          q: "Do I need a WhatsApp Business account?",
          a: "Yes — we'll set you up on the official Cloud API. Approval usually takes a few days; we handle the application.",
        },
        {
          q: "Can it route by area / agent?",
          a: "Yes. Round-robin, by area, by language, by shift — any logic you want.",
        },
        {
          q: "What about my existing CRM?",
          a: "We integrate with most CRMs (Salesforce, HubSpot, Monday, custom). If you don't have one, we can build a lightweight CRM tailored to real-estate.",
        },
      ],
    },

    "ecommerce-automation": {
      hero: {
        eyebrow: "For ecommerce brands",
        title: "Save 25+ hours a week with smart automations.",
        lede:
          "Stop copy-pasting orders between Shopify, your warehouse sheet, and customer email. We build automations that run while you sleep — and grow with your store.",
        primaryCta: "Automate my store",
        secondaryCta: "See examples",
        bullets: [
          "Order → fulfillment → shipping label, fully automated",
          "Customer support replies powered by your knowledge base",
          "Cart abandonment & post-purchase WhatsApp flows",
          "Custom dashboards across Shopify / WooCommerce / custom",
        ],
      },
      problems: {
        title: "Where ops time disappears",
        items: [
          "Manually pasting orders into the warehouse sheet every morning.",
          "Repeating the same support answers 50 times a week.",
          "Refunds and returns handled in 4 different tabs.",
        ],
      },
      solution: {
        title: "What we ship",
        items: [
          {
            t: "Order pipeline",
            d: "Order → label → warehouse → tracking — fully automated, with Slack alerts on exceptions.",
          },
          {
            t: "AI support inbox",
            d: "AI replies powered by your knowledge base. Escalates only what matters.",
          },
          {
            t: "WhatsApp flows",
            d: "Abandoned-cart and post-purchase flows on the channel your customers actually open.",
          },
          {
            t: "Ops dashboard",
            d: "One place to see orders, returns, support load — across all your tools.",
          },
        ],
      },
      proof: {
        title: "Real result",
        quote:
          "We cut about 25 hours of manual ops a week. The team stopped dreading Mondays.",
        name: "Or K.",
        role: "Marketing Lead, DTC brand",
      },
      pricing: {
        title: "Investment",
        priceFrom: "From $1,250",
        timeline: "1–2 weeks to live",
        includes: [
          "n8n / custom automations",
          "Shopify / WooCommerce / custom-store integrations",
          "AI support inbox",
          "Hosting + monitoring",
          "30 days of post-launch support",
        ],
      },
      faq: [
        {
          q: "Will it work with my Shopify theme?",
          a: "Yes — we work with vanilla Shopify, headless, WooCommerce, and custom stacks.",
        },
        {
          q: "Do I need to switch tools?",
          a: "No. We build on top of what you already have. New tools are added only if there's a clear ROI.",
        },
        {
          q: "What about Hebrew customer support?",
          a: "We support multilingual flows out of the box, including Hebrew RTL.",
        },
      ],
    },

    "booking-system-for-clinics-and-salons": {
      hero: {
        eyebrow: "For clinics, gyms & barber shops",
        title: "An online booking system your clients will actually use.",
        lede:
          "Stop chasing no-shows and answering booking calls all day. Your clients book online from their phone, get reminders on WhatsApp, and the front desk gets quiet again.",
        primaryCta: "Get my booking system",
        secondaryCta: "See how it works",
        bullets: [
          "Clients book 24/7 from their phone — no calls needed",
          "Automatic WhatsApp reminders cut no-shows",
          "All client info in one place — not in a notebook",
          "Take a deposit at booking — no-shows almost stop",
        ],
      },
      problems: {
        title: "Why your day disappears",
        items: [
          "Half the morning answers booking calls and 'do you have a slot?' messages.",
          "Clients no-show because they forget — and you never get the time back.",
          "Client info is scattered between paper, WhatsApp, and your head.",
        ],
      },
      solution: {
        title: "What we build",
        items: [
          {
            t: "Online booking",
            d: "Clients pick a time from your calendar. No phone call, no friction.",
          },
          {
            t: "Auto reminders",
            d: "WhatsApp + SMS reminders 24h and 2h before. No-shows quietly disappear.",
          },
          {
            t: "Client list",
            d: "One clean list with notes, history and tags. Like your memory, but searchable.",
          },
          {
            t: "Deposits at booking",
            d: "Charge a small deposit when they book. The no-show problem solves itself.",
          },
        ],
      },
      proof: {
        title: "Real result",
        quote:
          "We were losing two clients a week to no-shows. After we added reminders and a small deposit, the calendar stays full and the phone stopped ringing all day.",
        name: "Avi M.",
        role: "Owner, barber shop",
      },
      pricing: {
        title: "Investment",
        priceFrom: "From $1,500",
        timeline: "1–2 weeks to live",
        includes: [
          "Custom online booking page",
          "WhatsApp + SMS reminders",
          "Client list with notes & tags",
          "Optional deposits / online payments",
          "30 days of post-launch support",
        ],
      },
      faq: [
        {
          q: "Will my clients actually use it?",
          a: "Yes. Booking is 2 taps and the reminder lands on WhatsApp. No app to download. Works on any phone, even old ones.",
        },
        {
          q: "What about my staff who isn't great with computers?",
          a: "The admin side is built like a clean Excel sheet — but simpler. We train your team in 30 minutes.",
        },
        {
          q: "Can I take deposits?",
          a: "Yes. A small deposit at booking time almost eliminates no-shows overnight. We hook up Bit, credit card, or bank transfer.",
        },
        {
          q: "Does it work with what I already have?",
          a: "We replace the notebook or Excel with something faster, or connect to your current system if you already have one.",
        },
      ],
    },
  },

  portfolio: {
    eyebrow: "Selected work",
    title: "Real projects, real results.",
    lede:
      "A few recent builds — what the problem was, what we shipped, and what changed.",
    cta: "View case study",
    items: [
      {
        slug: "saas-dashboard",
        key: "saas-dashboard",
        tag: "SaaS · Full-Stack",
        title: "Analytics dashboard for a B2B SaaS",
        problem:
          "Customer support team spent hours pulling data manually from three tools.",
        solution:
          "Built a real-time dashboard with role-based access, alerting, and CSV export.",
        result: "Cut reporting time from 4h/day to under 5 minutes.",
        stack: ["React", "Node.js", "PostgreSQL"],
      },
      {
        slug: "wa-leadbot",
        key: "wa-leadbot",
        tag: "WhatsApp Bot · CRM",
        title: "WhatsApp lead bot for a real-estate agency",
        problem:
          "Agents missed inbound leads because messages got lost across phones.",
        solution:
          "Cloud API bot routing leads into a custom CRM with auto-reply and follow-ups.",
        result: "3× more booked viewings in the first month.",
        stack: ["WhatsApp Cloud API", "Node.js", "MongoDB"],
      },
      {
        slug: "landing-conversion",
        key: "landing-conversion",
        tag: "Landing Page",
        title: "High-conversion landing for a fitness coach",
        problem:
          "Original page was slow, generic, and converted under 1% of paid traffic.",
        solution:
          "Rebuilt with conversion-tuned copy, fast load, and embedded booking flow.",
        result: "Conversion rate jumped from 0.8% to 5.2%.",
        stack: ["React", "Stripe", "Calendly"],
      },
      {
        slug: "ops-automation",
        key: "ops-automation",
        tag: "Automation",
        title: "Order fulfillment automation for an e-commerce brand",
        problem:
          "Orders were copy-pasted between Shopify, the warehouse sheet, and email.",
        solution:
          "n8n workflow that syncs orders, prints labels, and pings the warehouse on Slack.",
        result: "Saved ~25 hours of manual work per week.",
        stack: ["n8n", "Shopify API", "Slack"],
      },
      {
        slug: "tg-community",
        key: "tg-community",
        tag: "Telegram Bot",
        title: "Community & payments bot for a paid Telegram channel",
        problem:
          "Manual approvals and Bit/PayBox handling didn't scale past a few hundred members.",
        solution:
          "Telegram bot with payment gating, auto-onboarding, and admin dashboard.",
        result: "Onboards new paying members in under 60 seconds.",
        stack: ["Telegram Bot API", "Node.js", "Stripe"],
      },
      {
        slug: "clinic-booking",
        key: "clinic-booking",
        tag: "Booking · Local Business",
        title: "Booking & client system for a family clinic",
        problem:
          "Patient info lived in a notebook and Excel. Reminders went out manually — when there was time.",
        solution:
          "Online booking page with auto WhatsApp reminders, a clean patient list, and deposits at booking.",
        result: "No-shows dropped from 22% to 4%. The front desk has time to breathe.",
        stack: ["React", "Node.js", "WhatsApp API"],
      },
    ],
    detail: {
      backToHome: "← Back to home",
      problemLabel: "The problem",
      solutionLabel: "What we built",
      resultLabel: "The result",
      stackLabel: "Stack",
      ctaTitle: "Want one like this?",
      ctaDesc:
        "We can build something similar for your business — usually live in 2–4 weeks.",
      ctaButton: "Start a project",
      relatedTitle: "Other work",
    },
  },

  testimonials: {
    eyebrow: "What clients say",
    title: "Trusted by teams who ship.",
    lede: "We're proud of the relationships we build, not just the code.",
    logosLabel: "Trusted by",
    logos: [
      { name: "Dr. Shay T." },
      { name: "Dolev H." },
      { name: "Tzahy Y." },
      { name: "Nitzan A." },
      { name: "Omer G." },
    ],
    items: [
      {
        quote:
          "Patient bookings used to eat my afternoons. Now reminders go out automatically and the waiting room actually runs on time.",
        name: "Dr. Shay T.",
        role: "Doctor",
      },
      {
        quote:
          "Members sign up online instead of calling at 10pm. Check-ins, payments, renewals — it all just happens. I got my evenings back.",
        name: "Dolev H.",
        role: "Gym owner",
      },
      {
        quote:
          "Booking a haircut used to be three WhatsApp messages back and forth. Now it's two taps. The shop runs itself.",
        name: "Tzahy Y.",
        role: "Owner, barber shop",
      },
      {
        quote:
          "Service requests used to live in screenshots and missed calls. Now every job has a number, a status, and a follow-up. Nothing falls through.",
        name: "Nitzan A.",
        role: "Owner, security cameras company",
      },
      {
        quote:
          "I used to spend half my week emailing renders and chasing approvals. Clients now view, comment, and sign off in one place — projects move much faster.",
        name: "Omer G.",
        role: "Architect & designer",
      },
    ],
  },

  roi: {
    eyebrow: "ROI calculator",
    title: "How much could automation save you?",
    lede:
      "Estimate your annual savings. Most automations pay for themselves in the first 2–3 months.",
    fields: {
      hours: "Hours per week your team spends on manual work",
      rate: "Average hourly cost (USD)",
      teamSize: "How many people on the team?",
    },
    annualSavedLabel: "Annual time-cost saved",
    paybackLabel: "Payback period",
    paybackUnits: "months",
    cta: "Get a quote based on this",
    note: "Estimate only. Real number depends on scope.",
  },

  pricing: {
    eyebrow: "Pricing",
    title: "Pick a starting point.",
    lede:
      "Transparent starting prices. Final scope is shaped together in the kickoff call.",
    note: "Final scope quoted after a free 20-min discovery call.",
    cta: "Get started",
    currencyToggle: { usd: "USD ($)", ils: "ILS (₪)" },
    plans: [
      {
        key: "launch",
        name: "Launch",
        priceFromUSD: 625,
        priceLabelUSD: "From $625",
        priceLabelILS: "החל מ-₪2,250",
        tagline: "Landing pages & marketing sites",
        features: [
          "Landing page built to convert",
          "Looks perfect on every phone",
          "Loads in under 2 seconds",
          "Google search ready",
          "Up to 2 rounds of revisions",
          "Delivered in 3–7 days",
        ],
        ctaLabel: "Start a landing page",
      },
      {
        key: "automate",
        name: "Automate",
        priceFromUSD: 1300,
        priceLabelUSD: "From $1,300",
        priceLabelILS: "החל מ-₪4,700",
        tagline: "Bots & automations",
        features: [
          "Telegram or WhatsApp bot",
          "Workflows built to fit your business",
          "Connects to the tools you already use",
          "Simple admin dashboard",
          "We host & monitor it",
          "Delivered in 1–2 weeks",
        ],
        ctaLabel: "Automate my work",
      },
      {
        key: "build",
        name: "Build",
        priceFromUSD: 3125,
        priceLabelUSD: "From $3,125",
        priceLabelILS: "החל מ-₪11,250",
        tagline: "Full-stack apps & custom CRMs",
        features: [
          "Full system, end to end",
          "Logins, payments, dashboards",
          "Always online & always updated",
          "Built around your real workflow",
          "30 days post-launch support",
          "Delivered in 2–4 weeks",
        ],
        ctaLabel: "Build my system",
      },
    ],
  },

  guarantee: {
    eyebrow: "How we work",
    title: "Clear scope. Honest timeline. No surprises.",
    lede:
      "We agree on price, scope, and milestones before any code gets written — so you always know what you're getting and when.",
    items: [
      {
        icon: "shield",
        title: "Fixed price up front",
        desc: "Quoted before we start. No scope creep, no surprise invoices.",
      },
      {
        icon: "lock",
        title: "Weekly milestones",
        desc: "You see real progress every week and sign off as we go.",
      },
      {
        icon: "code",
        title: "You own everything",
        desc: "Once paid, the code lives in your GitHub, your domain, your cloud.",
      },
      {
        icon: "support",
        title: "30 days post-launch",
        desc: "Bugs and small tweaks included after we ship.",
      },
    ],
  },

  process: {
    eyebrow: "How we work",
    title: "From idea to live in weeks, not months.",
    lede:
      "A simple, transparent four-step process. No black box, no surprise invoices.",
    steps: [
      { n: "01", title: "Discover", desc: "We map your goals, users, and constraints in a focused kickoff call." },
      { n: "02", title: "Design", desc: "Wireframes and brand-aligned visuals so you see it before we build it." },
      { n: "03", title: "Build", desc: "Clean, well-tested code. Daily updates. Deploy on every commit." },
      { n: "04", title: "Launch", desc: "Ship to production, monitor, iterate. Plus 30 days of post-launch support." },
    ],
  },

  about: {
    eyebrow: "Who's behind NKR",
    title: "Hi, I'm Nave.",
    lede:
      "I build websites, booking systems and automations for small businesses — clinics, gyms, barber shops, real-estate agents and online stores. The kind of stuff that quietly saves you hours every week.",
    points: [
      "I do everything myself — design, build and launch.",
      "Everything I build is yours — code, domain, and accounts.",
      "Updates on WhatsApp. You always know where things stand.",
    ],
    cta: "Let's talk",
    initials: "NKR",
  },

  stack: {
    eyebrow: "Toolkit",
    title: "Built on tools that scale.",
    lede:
      "We pick the right tool for the job — no over-engineering, no trends-for-trends-sake.",
    skills: {
      Languages: ["Java", "JavaScript", "Python", "SQL"],
      Frameworks: ["Spring Boot", "Hibernate", "React", "Node.js"],
      Databases: ["MySQL", "MongoDB"],
      Architecture: ["REST APIs", "Microservices", "OOP", "Design Patterns"],
      Tools: ["Git", "Jenkins", "Jira", "VS Code", "IntelliJ"],
      Methodologies: ["Agile/Scrum", "CI/CD", "Unit Testing", "Clean Code"],
    },
  },

  faq: {
    eyebrow: "FAQ",
    title: "Things people ask before they hit 'send'.",
    lede: "Short answers. If yours isn't here, just message us — we reply fast.",
    items: [
      { q: "How long does a project take?", a: "A landing page is 3–7 days. A bot or automation is usually 1–2 weeks. A full-stack app is typically 2–4 weeks. We give you a clear timeline before you commit." },
      { q: "Do I own the code?", a: "Always. The code lives in your GitHub, on your domain, on your cloud. No lock-in, ever." },
      { q: "What if I need changes after launch?", a: "Every project includes 30 days of post-launch support for fixes and tweaks. After that you can hire us hourly, on retainer, or run with the code yourself." },
      { q: "Do you sign NDAs?", a: "Yes, no problem. We can sign your NDA or use a standard mutual one before any sensitive details are shared." },
      { q: "How do payments work?", a: "Usually 50% up-front to start, 50% on launch. For longer projects we split into milestones. Bank transfer or Stripe." },
      { q: "Can you work with my existing team / designer?", a: "Definitely. We collaborate well with in-house teams, designers, and other agencies — whatever helps you ship faster." },
      { q: "Do you build with AI?", a: "Yes — OpenAI, Anthropic, and on-device models when needed. We add AI where it actually helps, not just because it's trendy." },
      { q: "What's the smallest project you take?", a: "A single landing page is fair game. If your idea is even smaller, ping us — we might know someone who's a better fit." },
    ],
  },

  banner: {
    title: "Not ready for a full project?",
    desc: "Book a free 20-minute audit. We'll review your site, bot, or workflow and send you 3 quick wins — no strings attached.",
    cta: "Book free audit",
  },

  contact: {
    eyebrow: "Let's talk",
    title: "Tell us what you want to build.",
    lede: "A few details and we'll reply within 24 hours with next steps.",
    bookCta: "Book a 20-min intro call",
    orDivider: "or send a brief",
    form: {
      name: "Your name",
      email: "Your email",
      projectType: "Project type",
      projectTypeOptions: [
        { value: "", label: "Select project type" },
        { value: "landing", label: "Landing page" },
        { value: "fullstack", label: "Full-stack app" },
        { value: "automation", label: "Automation" },
        { value: "crm", label: "Custom CRM" },
        { value: "telegram", label: "Telegram bot" },
        { value: "whatsapp", label: "WhatsApp bot" },
        { value: "other", label: "Something else" },
      ],
      budget: "Budget range",
      budgetOptions: [
        { value: "", label: "Select budget" },
        { value: "under-2k", label: "Under $2,000" },
        { value: "2-5k", label: "$2,000 – $5,000" },
        { value: "5-15k", label: "$5,000 – $15,000" },
        { value: "15k+", label: "$15,000+" },
        { value: "not-sure", label: "Not sure yet" },
      ],
      timeline: "Timeline",
      timelineOptions: [
        { value: "", label: "Select timeline" },
        { value: "asap", label: "ASAP / this week" },
        { value: "1m", label: "Within 1 month" },
        { value: "1-3m", label: "1–3 months" },
        { value: "exploring", label: "Just exploring" },
      ],
      stage: "Stage",
      stageOptions: [
        { value: "", label: "Select stage" },
        { value: "pre-revenue", label: "Pre-revenue / idea" },
        { value: "early", label: "Early revenue" },
        { value: "growing", label: "Growing business" },
        { value: "established", label: "Established" },
      ],
      message: "Anything else?",
      submit: "Send the brief",
      sending: "Sending…",
      success: "Got it — we'll be in touch within 24h.",
      error: "Couldn't send. Please try again or email us directly.",
      spamDetected: "Your message looked automated to our filter. If this is a real inquiry, please email us directly.",
    },
  },

  exitIntent: {
    title: "Wait — grab a free audit before you go.",
    desc:
      "Drop your email and we'll send you 3 quick wins for your site, bot, or workflow within 24h. No sales call, no spam.",
    emailLabel: "Your email",
    submit: "Send my free audit",
    sending: "Sending…",
    success: "Thanks! Check your inbox in the next 24h.",
    error: "Hmm, that didn't go through. Try again or email us directly.",
    close: "No thanks",
    later: "Maybe later",
  },

  mobileSticky: {
    primary: "Start a project",
    secondary: "WhatsApp",
  },

  footer: "Software that ships.",
};
